"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ContextSelector = require("../ContextSelector");

// const BodyContext = React.createContext<BodyContextProps>(null);
var BodyContext = (0, _ContextSelector.createContext)();
var _default = BodyContext;
exports.default = _default;